import type {
  HubAlgorithmDefinition,
  HubDatasetDependency,
} from '@robovision/hub'
import {
  JobBaseDependency,
  type JobBaseDependencyParams,
} from './JobBaseDependency'


export interface JobDatasetDependencyParams extends JobBaseDependencyParams {
  exampleDefinition: string
  optional: boolean
  test: boolean
}

export class JobDatasetDependency extends JobBaseDependency {
  public exampleDefinition: string
  public optional: boolean
  public test: boolean

  protected constructor (params: JobDatasetDependencyParams) {
    super(params)
    this.exampleDefinition = params.exampleDefinition
    this.optional = params.optional
    this.test = params.test
  }

  public static fromDefinition (
    datasetDependency: HubDatasetDependency,
    algorithmDefinition: HubAlgorithmDefinition,
  ) {
    const datasetDef = algorithmDefinition.datasetDefinitions?.find(
      (def) => def.id === datasetDependency.datasetDefinition,
    )

    if (!datasetDef) {
      throw new Error(
        `Invalid schema. Dataset definition ${datasetDependency.datasetDefinition} not found`,
      )
    }

    return new JobDatasetDependency({
      definitionId: datasetDef.id,
      dependencyId: datasetDependency.id,
      description: datasetDependency.description,
      exampleDefinition: datasetDef.exampleDefinition,
      name: datasetDependency.name,
      optional: datasetDependency.optional ?? false,
      test: !!datasetDependency.test,
    })
  }
}
